module.exports = __webpack_public_path__ + "static/media/stanley.3609045e.jpg";